import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchAuth } from '../../../ducks/auth'

import AuthForm from '../../../components/Forms/AuthForm'

class AuthPage extends Component {
  handleSubmitForm = (values) => {
    this.props.fetchAuth(values)
  }

  render() {
    const { loading, error } = this.props.auth

    return (
      <AuthForm
        loading={loading}
        errorMessage={error}
        onSubmit={this.handleSubmitForm}
      />
    )
  }
}

export default connect(
  (state) => ({
    auth: state.auth
  }),
  { fetchAuth }
)(AuthPage)
